import { useState, useEffect } from 'react';
import { auth } from './firebase';
import { 
  signInWithEmailAndPassword,
  onAuthStateChanged 
} from 'firebase/auth';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Members from './components/Members';
import TrainingAdmin from './components/TrainingAdmin';
import OverallCourseRating from './components/OverallCourseRating';
import LabRegistration from './components/LabRegistration';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthenticated(!!user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      setError('');
    } catch (error) {
      setError(error.message);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/lab-registration" element={<LabRegistration />} />
        {isAuthenticated ? (
          <>
            <Route path="/members" element={<Members />} />
            <Route path="/admin/training" element={<TrainingAdmin />} />
            <Route path="/course-ratings" element={<OverallCourseRating />} />
            <Route path="/" element={<Navigate to="/members" replace />} />
          </>
        ) : (
          <Route path="*" element={
            <div className="App">
              <header className="App-header">
                <h1>Welcome to FileSig Events</h1>
                <div className="login-container">
                  <h2>Login</h2>
                  {error && <p className="error">{error}</p>}
                  <form onSubmit={handleLogin}>
                    <div className="form-group">
                      <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>
                    <button type="submit">Login</button>
                  </form>
                </div>
              </header>
            </div>
          } />
        )}
      </Routes>
    </Router>
  );
}

export default App;
